import { render, staticRenderFns } from "./SettingSide.vue?vue&type=template&id=5dd0fae2&"
import script from "./SettingSide.vue?vue&type=script&lang=js&"
export * from "./SettingSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports